<script lang="ts">
  let { message, retry } = $props<{ message: string; retry: () => void }>();
</script>

<div class="rounded-xl border border-base-300 bg-base-100 p-5 space-y-3">
  <p role="alert" class="text-sm text-base-content">{message}</p>
  <button class="btn btn-sm btn-outline" onclick={retry}>Retry</button>
</div>
